const MODULE = "Retain Extra Passes"
const RETAIN_EXTRA_PASSES_MODULE_ID = 8
const RETAIN_EXTRA_PASSES_HELP_KEY = "retain_canceled_appointments_v001"

const MODULE_DESCRIPTION =
  "Retain additional canceled appointments and student appointment requests that are not confirmed."

const PATHS = Object.freeze({
  ROOT: "/appointments/retained",
  LIST: "/appointments/retained/list"
})

const RETAIN_EXTRA_PASSES_ADMIN_ROLES = ["superadmin", "admin"]

const ROUTE_DEPENDENCY = Object.freeze({
  LIST: "routerDependencies/hasRetainedModuleRouteAccess"
})

const RETAINED_APPOINTMENTS_ENDPOINT = "/admin/appointments/retained"

export default {
  MODULE,
  MODULE_DESCRIPTION,
  RETAIN_EXTRA_PASSES_MODULE_ID,
  PATHS,
  RETAIN_EXTRA_PASSES_ADMIN_ROLES,
  ROUTE_DEPENDENCY,
  RETAIN_EXTRA_PASSES_HELP_KEY,
  RETAINED_APPOINTMENTS_ENDPOINT
}
